import React from "react";
import ReactDOM from "react-dom";
import { noop } from "../utils";
import styles from "./overlay.css";

interface Props {
  className?: string;
  onClick?: () => any;
}

export class Overlay extends React.Component<Props, {}> {
  el: HTMLDivElement;

  constructor(props: Props) {
    super(props);
    this.el = document.createElement("div");
    this.el.setAttribute("class", styles.overlay + " " + (this.props.className || ""));
  }

  componentDidMount() {
    document.body.appendChild(this.el);
    this.el.addEventListener("click", this.props.onClick || noop);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
